import { DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';
import { Payload } from '../payload.js';
import { PayloadType } from '../payload-type.js';
import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneDataOrNull, isSameData } from '../../../dto/data-model-utils.js';

export class ErrorPayload extends Payload {
  static readonly TYPE_ID = '751e58c4c6e24398ba8f2a573578c8c1';

  private constructor(
    public readonly error: string,
    public readonly innerException: ErrorPayload | null,
  ) {
    super();
  }

  get $typeId(): string {
    return ErrorPayload.TYPE_ID;
  }

  get type(): PayloadType {
    return PayloadType.Error;
  }

  static create(args: {
    error: string;
    innerException: ErrorPayload | null;
  }): ErrorPayload {
    return new ErrorPayload(args.error, args.innerException);
  }

  static fromMap(context: SerializationContext, map: SerializedData): ErrorPayload {
    return ErrorPayload.create({
      error: MapUtils.getString(map, 'error'),
      innerException: context.fromDataOrNull<ErrorPayload>(MapUtils.getRecordOrNull(map, 'innerException')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'error': this.error,
      'innerException': context.toDataOrNull(this.innerException),
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    error = this.error,
    innerException = cloneDataOrNull(this.innerException),
  }: {
    error?: string;
    innerException?: ErrorPayload | null;
  } = {}): this {
    return ErrorPayload.create({ error, innerException }) as this;
  }

  isSame(other: ErrorPayload): boolean {
    return this === other || (
      this.error === other.error &&
      isSameData(this.innerException, other.innerException)
    );
  }
}

export class ErrorPayloadBuilder extends DataModelBuilder<ErrorPayload> {
  build(context: SerializationContext, map: SerializedData): ErrorPayload {
    return ErrorPayload.fromMap(context, map);
  }
}
